import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundL1Alpha,
  },
  containerPressed: {
    backgroundColor: colors.backgroundBrand,
    borderColor: colors.backgroundBrand,
  },
  avatar: {
    justifyContent: 'center',
  },
  content: {
    flex: 1,
  },
  contentWrapper: {
    alignItems: 'flex-start',
  },
  distance: {
    fontSize: 12,
    color: colors.textTertiary,
    marginBottom: 8,
  },
  divider: {
    width: '10%',
    height: 1,
    backgroundColor: colors.borderPrimary,
    marginVertical: theme.spacing[2],
  },
  footerContainer: {
    justifyContent: 'space-between',
  },

  directionsButton: {
    maxHeight: 24,
    paddingLeft: 0,
  },
}));
